import Emp900ComprobantesPage from './Emp900ComprobantesPage'

export default function Emp900RecibosPage() {
  return <Emp900ComprobantesPage tipo="recibo" />
}
